import handler from 'api/handler'

const prefix = '/userAdmin/userMedia'

const methods = {
  upload: args => handler({ method: 'post', url: prefix + '/upload', args, isFile: true }),
  fetchAll: args => handler({ method: 'get', url: prefix + '/fetchAll', args }),
  fetch: args => handler({ method: 'get', url: prefix + '/fetch', args }),
  delete: args => handler({ method: 'delete', url: prefix + '/delete', args }),
  update: args => handler({ method: 'put', url: prefix + '/update', args })
}

export default methods
